<template>
  <pt-adult-sell-order-handle class="pt-adult-sell-order-handle__page"></pt-adult-sell-order-handle>
</template>

<script>
import PtAdultSellOrderHandle from 'cps/adult-sell-order/pt-adult-sell-order-handle/withData'
export default {
  name: 'pt-adult-sell-order-handle__view',
  components: {
    'pt-adult-sell-order-handle': PtAdultSellOrderHandle
  }
}
</script>
